import React from "react";

const experienceContent = [
  {
    year: "   Nov 2024 - Present",
    position: " Engineer Trainee",
    compnayName: "Bansal Precision Forge Pvt Ltd",
    details: `Maintenance Engineer responsible for implementing Preventive and Predictive Maintenance strategies. Managing daily maintenance operations, developing maintenance plans and checksheets. Performing KPI analysis including MTBF and MTTR calculations. Maintaining critical spare parts inventory and ensuring IATF documentation compliance.`,
  },
];

const Experience = () => {
  return (
    <ul>
      {experienceContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.position}
            <span className="place open-sans-font">{val.compnayName}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Experience;
